import { story1 } from 'api/forbesMock/forbesMockStoriesData';

export interface IGetLastOpenedStoryResponse {
    hashId: string;
}

export const forbesMockGetLastOpenedStory = async (): Promise<IGetLastOpenedStoryResponse> =>
    Promise.resolve({ hashId: story1().hashId });
